import React from 'react';
import { IPhoto } from 'btdt-types';
import config from '../../../../config';

interface IProps {
  photos: IPhoto[];
  initialIndex: number;
  onClose(): void;
}

function getPhotoUrl(url: string): string {
  if (url.startsWith('http')) return url;
  return config.apiBaseUrl.replace(/\/$/, '') + url;
}

function PhotoLightbox({ photos, initialIndex, onClose }: IProps): React.ReactElement {
  const [currentIndex, setCurrentIndex] = React.useState(initialIndex);
  const photo = photos[currentIndex];

  React.useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') setCurrentIndex((i) => (i > 0 ? i - 1 : photos.length - 1));
      if (e.key === 'ArrowRight') setCurrentIndex((i) => (i < photos.length - 1 ? i + 1 : 0));
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose, photos.length]);

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div className="PhotoLightbox" onClick={handleBackdropClick}>
      <button className="PhotoLightbox-close" onClick={onClose}>&times;</button>
      {photos.length > 1 && (
        <>
          <button
            className="PhotoLightbox-nav PhotoLightbox-nav--prev"
            onClick={() => setCurrentIndex((i) => (i > 0 ? i - 1 : photos.length - 1))}
          >
            &#8249;
          </button>
          <button
            className="PhotoLightbox-nav PhotoLightbox-nav--next"
            onClick={() => setCurrentIndex((i) => (i < photos.length - 1 ? i + 1 : 0))}
          >
            &#8250;
          </button>
        </>
      )}
      <div className="PhotoLightbox-content">
        <img src={getPhotoUrl(photo.url)} alt={photo.caption || ''} />
        {photo.caption && <div className="PhotoLightbox-caption">{photo.caption}</div>}
        {photo.credit && <div className="PhotoLightbox-credit">{photo.credit}</div>}
      </div>
    </div>
  );
}

export default PhotoLightbox;
